module.exports = __webpack_public_path__ + "static/banner_image.d83e472a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner_image.jpg
// module id = 394
// module chunks = 114276838955818